import React from "react";
import { ColorIconProps, getColorIconSize } from "./utils";

const ProSearchIcon: React.FC<ColorIconProps> = ({
  size = "default",
  className,
}) => {
  return (
    <svg
      width={getColorIconSize(size)}
      height={getColorIconSize(size)}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_43_23345)">
        <path
          d="M12.5 5.93245L12.4959 5.85026C12.477 5.65953 12.3926 5.47998 12.2559 5.34326C12.0996 5.18707 11.8876 5.09912 11.6667 5.09912L8.33333 5.09912C8.11239 5.09912 7.90041 5.18708 7.74414 5.34326C7.58793 5.49948 7.50007 5.71154 7.5 5.93245L7.5 8.28434C7.5 8.74458 7.8731 9.11768 8.33333 9.11768H11.6667L11.7521 9.11361C12.1722 9.07083 12.5 8.71574 12.5 8.28434V5.93245Z"
          fill="var(--cdl-accent-bg-base)"
        />
        <path
          d="M14.7657 2.32568C16.2307 2.44463 17.4933 3.43976 17.9395 4.86068L19.8324 10.8877C19.9203 11.1678 19.8539 11.4736 19.6582 11.6925L19.0918 12.3265C18.9337 12.5034 18.7074 12.6048 18.4701 12.6048H11.6667C11.2065 12.6048 10.8334 12.2317 10.8334 11.7715V5.95036C10.8334 3.94196 12.4619 2.31348 14.4703 2.31348L14.7657 2.32568Z"
          fill="var(--cdl-accent-bg-base)"
        />
        <path
          d="M15.4167 8.43255C13.3457 8.43255 11.6667 10.1114 11.6667 12.1824C11.6667 14.2534 13.3457 15.9323 15.4167 15.9323C17.4878 15.9323 19.1667 14.2534 19.1667 12.1824C19.1667 10.1114 17.4878 8.43255 15.4167 8.43255Z"
          fill="var(--cdl-bg-faint)"
        />
        <path
          d="M15.4167 9.26566C17.0275 9.26566 18.3333 10.5716 18.3334 12.1823C18.3334 13.7931 17.0276 15.099 15.4167 15.099C13.8059 15.099 12.5001 13.7931 12.5001 12.1823C12.5001 10.5716 13.8059 9.26566 15.4167 9.26566ZM15.4167 7.59899C12.8855 7.59899 10.8334 9.65111 10.8334 12.1823C10.8334 14.7136 12.8854 16.7657 15.4167 16.7657C17.948 16.7657 20.0001 14.7136 20.0001 12.1823C20 9.65111 17.948 7.59899 15.4167 7.59899Z"
          fill="currentColor"
        />
        <path
          d="M18.1771 10.9424L14.1862 14.9331C15.3867 15.5118 16.6568 15.2091 17.5545 14.3114C18.4522 13.4137 18.6716 12.1142 18.1771 10.9424Z"
          fill="currentColor"
        />
        <path
          d="M9.16702 11.7715C9.16702 12.2316 8.79375 12.6046 8.33368 12.6048H1.52948C1.29236 12.6047 1.06656 12.5033 0.908553 12.3265L0.341333 11.6925C0.145804 11.4736 0.0800791 11.1678 0.167993 10.8877L2.0609 4.86068L2.16099 4.58236C2.71332 3.2201 4.0407 2.31348 5.53014 2.31348L5.71731 2.31836C7.63872 2.41578 9.16702 4.00474 9.16702 5.95036V11.7715Z"
          fill="var(--cdl-accent-bg-base)"
        />
        <path
          d="M4.58333 8.43255C2.51227 8.43255 0.833334 10.1114 0.833334 12.1824C0.833334 14.2534 2.51227 15.9323 4.58333 15.9323C6.6544 15.9323 8.33333 14.2534 8.33333 12.1824C8.33333 10.1114 6.6544 8.43255 4.58333 8.43255Z"
          fill="var(--cdl-bg-faint)"
        />
        <path
          d="M4.58333 9.26566C6.19415 9.26566 7.49994 10.5716 7.5 12.1823C7.5 13.7931 6.19419 15.099 4.58333 15.099C2.97248 15.099 1.66667 13.7931 1.66667 12.1823C1.66673 10.5716 2.97252 9.26566 4.58333 9.26566ZM4.58333 7.59899C2.05209 7.59899 6.23892e-05 9.65111 0 12.1823C-1.10649e-07 14.7136 2.05205 16.7657 4.58333 16.7657C7.11461 16.7657 9.16667 14.7136 9.16667 12.1823C9.1666 9.65111 7.11458 7.59899 4.58333 7.59899Z"
          fill="currentColor"
        />
        <path
          d="M7.34373 10.9424L3.35286 14.9331C4.5533 15.5118 5.82339 15.2091 6.72109 14.3114C7.61878 13.4137 7.83823 12.1142 7.34373 10.9424Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_43_23345">
          <rect width="20" height="20" fill="var(--cdl-bg-faint)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ProSearchIcon;
